// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.toast {\n    background-color: #f2f2f2;\n}\n\n.toast-container {\n    z-index: 1100;\n    position: absolute;\n    width: 100%;\n    bottom: 20px;\n    max-width: 100% !important;\n}\n\n@media (min-width: 576px) {\n    .container, .container-sm {\n        width: 530px !important;\n    }\n}", ""]);
// Exports
module.exports = exports;
